import { ArrowUpRight, ShieldCheck } from "lucide-react";
import { WA_DEMO } from "../../lib/site";
import { SectionHeading } from "./SectionHeading";
import { Reveal, MaskedLine } from "./Reveal";
import { Magnetic } from "./Magnetic";

export const Payment = () => (
  <section id="pricing" data-testid="payment-section" className="relative py-24 sm:py-32 scroll-mt-20" aria-label="How you pay">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHeading
        eyebrow="How You Pay"
        lines={[<>Zero risk.</>, <>Zero <em className="italic text-brand">pressure.</em></>]}
        className="mb-14"
      />

      <Reveal>
        <div className="overflow-hidden border border-brand/60" data-testid="payment-card">
          <div className="relative bg-brand text-ink p-9 sm:p-16 lg:p-20 flex flex-col justify-between overflow-hidden">
            <span className="absolute -top-8 -right-4 font-display italic font-light text-[10rem] leading-none text-ink/10 select-none" aria-hidden="true">₹</span>
            <div>
              <ShieldCheck size={34} strokeWidth={1.4} className="mb-8" />
              <h3 className="font-display font-light text-4xl sm:text-5xl leading-[1.05]" data-testid="payment-headline">
                You only pay once you <em className="italic">love it.</em>
              </h3>
              <p className="mt-5 text-ink/75 font-medium max-w-md leading-relaxed">
                Most agencies take money first, then show you a design. We do the opposite — your
                design comes first, built with your real business info. Money enters only after you approve.
              </p>
            </div>
            <Magnetic className="mt-10">
              <a
                data-testid="payment-demo-button"
                href={WA_DEMO}
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center gap-3 bg-ink text-white pl-6 pr-1.5 py-1.5 text-sm font-semibold w-fit"
              >
                Claim your free demo
                <span className="btn-arrow-box !border-brand/60 !text-brand"><ArrowUpRight size={15} /></span>
              </a>
            </Magnetic>
          </div>
        </div>
      </Reveal>

      <Reveal delay={0.15}>
        <p className="mt-8 text-center font-mono text-[11px] tracking-[0.22em] uppercase text-mute" data-testid="payment-trust-line">
          No advance until you approve the demo · Balance only on launch day
        </p>
      </Reveal>
    </div>
  </section>
);
